export class RestoreRdsSubnetGroups {
    'region';
    'rdsSubnetGroups';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "rdsSubnetGroups",
            "baseName": "rdsSubnetGroups",
            "type": "Array<RestoreRdsSubnetGroupsRdsSubnetGroupsInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreRdsSubnetGroups.attributeTypeMap;
    }
    constructor() {
    }
}
